import React from 'react';
import cn from 'classnames';

import styles from './Spinner.module.scss';

export const SpinnerSize = {
  xs: 'xs',
  sm: 'sm',
  m: 'm'
} as const;

export type SpinnerSizeType = (typeof SpinnerSize)[keyof typeof SpinnerSize];

type Props = {
  size?: SpinnerSizeType;
  className?: string;
};

const Spinner: React.FC<Props> = ({ size = SpinnerSize.sm, className }) => {
  return (
    <span
      className={cn(styles.spinner, styles[`spinner_${size}`], className)}
    />
  );
};

export default React.memo(Spinner);
